module.exports = __webpack_public_path__ + "img/comments.bde010a8.svg";